/* eslint-disable object-property-newline */
const localizedSpecialtyPathPrefixes = [
    { englishUrlPrefix: 'acupuncturists', spanishUrlPrefix: 'acupunturistas' },
    { englishUrlPrefix: 'allergists', spanishUrlPrefix: 'alergista' },
    { englishUrlPrefix: 'audiologists', spanishUrlPrefix: 'audiólogos' },
    { englishUrlPrefix: 'cardiologists', spanishUrlPrefix: 'cardiólogos' },
    { englishUrlPrefix: 'surgeons', spanishUrlPrefix: 'cirujanos' },
    { englishUrlPrefix: 'hand-surgeons', spanishUrlPrefix: 'cirujanos-de-las-manos' },
    { englishUrlPrefix: 'oral-surgeons', spanishUrlPrefix: 'cirujanos-orales' },
    { englishUrlPrefix: 'orthopedic-surgeons', spanishUrlPrefix: 'cirujanos-ortopédicos' },
    { englishUrlPrefix: 'plastic-surgeons', spanishUrlPrefix: 'cirujanos-plásticos' },
    { englishUrlPrefix: 'dentists', spanishUrlPrefix: 'dentistas' },
    { englishUrlPrefix: 'pediatric-dentists', spanishUrlPrefix: 'dentistas-pediátricos' },
    { englishUrlPrefix: 'dermatologists', spanishUrlPrefix: 'dermatólogos' },
    { englishUrlPrefix: 'dietitians', spanishUrlPrefix: 'dietista' },
    { englishUrlPrefix: 'eye-doctors', spanishUrlPrefix: 'doctores-de-ojos' },
    { englishUrlPrefix: 'endocrinologists', spanishUrlPrefix: 'endocrinólogos' },
    { englishUrlPrefix: 'endodontists', spanishUrlPrefix: 'endodoncistas' },
    { englishUrlPrefix: 'nurse-practitioners', spanishUrlPrefix: 'enfermeras-profesionales' },
    { englishUrlPrefix: 'infertility-specialists', spanishUrlPrefix: 'especialista-en-infertilidad' },
    { englishUrlPrefix: 'hearing-specialist', spanishUrlPrefix: 'especialistas-en-audición' },
    { englishUrlPrefix: 'infectious-disease-specialists', spanishUrlPrefix: 'especialistas-enfermedades-infecciosas' },
    { englishUrlPrefix: 'pain-management-specialists', spanishUrlPrefix: 'especialistas-manejo-dolor' },
    { englishUrlPrefix: 'sleep-medicine-specialists', spanishUrlPrefix: 'especialistas-medicina-del-sueño' },
    { englishUrlPrefix: 'sports-medicine-specialists', spanishUrlPrefix: 'especialistas-medicina-deporte' },
    { englishUrlPrefix: 'travel-medicine-specialists', spanishUrlPrefix: 'especialistas-medicina-viajes' },
    { englishUrlPrefix: 'pediatric-urgent-care-specialists', spanishUrlPrefix: 'especialistas-pediátricos-de-urgencia' },
    { englishUrlPrefix: 'physiatrists', spanishUrlPrefix: 'fisiatras' },
    { englishUrlPrefix: 'gastroenterologists', spanishUrlPrefix: 'gastroenterólogos' },
    { englishUrlPrefix: 'obgyns', spanishUrlPrefix: 'ginecologo-obstetra' },
    { englishUrlPrefix: 'hematologists', spanishUrlPrefix: 'hematólogos' },
    { englishUrlPrefix: 'internists', spanishUrlPrefix: 'internistas' },
    { englishUrlPrefix: 'urgent-care-specialists', spanishUrlPrefix: 'los-especialistas-de-atención-de-urgencia' },
    { englishUrlPrefix: 'primary-care-doctors', spanishUrlPrefix: 'médicos-atención-primaria' },
    { englishUrlPrefix: 'emergency-medicine-physicians', spanishUrlPrefix: 'médicos-de-emergencia' },
    { englishUrlPrefix: 'family-physicians', spanishUrlPrefix: 'médicos-familiares' },
    { englishUrlPrefix: 'naturopathic-doctors', spanishUrlPrefix: 'naturópatas' },
    { englishUrlPrefix: 'nephrologists', spanishUrlPrefix: 'nefrólogos' },
    { englishUrlPrefix: 'pulmonologists', spanishUrlPrefix: 'neumólogos' },
    { englishUrlPrefix: 'neurosurgeons', spanishUrlPrefix: 'neurocirujanos' },
    { englishUrlPrefix: 'neurologists', spanishUrlPrefix: 'neurólogos' },
    { englishUrlPrefix: 'nutritionists', spanishUrlPrefix: 'nutricionistas' },
    { englishUrlPrefix: 'ophthalmologists', spanishUrlPrefix: 'oftalmólogos' },
    { englishUrlPrefix: 'oncologists', spanishUrlPrefix: 'oncólogos' },
    { englishUrlPrefix: 'optometrists', spanishUrlPrefix: 'optometras' },
    { englishUrlPrefix: 'orthodontists', spanishUrlPrefix: 'ortodoncistas' },
    { englishUrlPrefix: 'ear-nose-throat-doctors', spanishUrlPrefix: 'otorrinolaringólogos' },
    { englishUrlPrefix: 'pediatricians', spanishUrlPrefix: 'pediatras' },
    { englishUrlPrefix: 'periodontists', spanishUrlPrefix: 'periodoncistas' },
    { englishUrlPrefix: 'podiatrists', spanishUrlPrefix: 'podiatras' },
    { englishUrlPrefix: 'prosthodontists', spanishUrlPrefix: 'prostodoncistas' },
    { englishUrlPrefix: 'psychologists', spanishUrlPrefix: 'psicólogos' },
    { englishUrlPrefix: 'psychotherapists', spanishUrlPrefix: 'psicoterapeuta' },
    { englishUrlPrefix: 'psychiatrists', spanishUrlPrefix: 'psiquiatras' },
    { englishUrlPrefix: 'chiropractors', spanishUrlPrefix: 'quiroprácticos' },
    { englishUrlPrefix: 'radiologists', spanishUrlPrefix: 'radiologos' },
    { englishUrlPrefix: 'rheumatologists', spanishUrlPrefix: 'reumatólogos' },
    { englishUrlPrefix: 'therapist-counselors', spanishUrlPrefix: 'terapeutas-consejeros' },
    { englishUrlPrefix: 'physical-therapists', spanishUrlPrefix: 'terapeutas-físicos' },
    { englishUrlPrefix: 'urologists', spanishUrlPrefix: 'urólogos' },
];

const specialtyPathPrefixes = [];
const spanishSpecialtyPrefixes = [];
const localizedUrlMap = { };
localizedSpecialtyPathPrefixes.forEach(specialty => {
    const encodedSpanishUrl = encodeURIComponent(specialty.spanishUrlPrefix);

    specialtyPathPrefixes.push(`/${specialty.englishUrlPrefix}`);
    spanishSpecialtyPrefixes.push(`/${encodedSpanishUrl}`);
    localizedUrlMap[specialty.englishUrlPrefix.toLowerCase()]
         = { default: specialty.englishUrlPrefix, other: encodedSpanishUrl };
    localizedUrlMap[encodedSpanishUrl.toLowerCase()]
        = { default: specialty.englishUrlPrefix, other: specialty.englishUrlPrefix };
});

const reactRouterifiedSpecialtyPathPrefixes = specialtyPathPrefixes
    .concat(spanishSpecialtyPrefixes)
    .map(x => `${x}(/:threat2)(/:threat3)`);

const procedurePathPrefixes = [
    '/procedure',
];

const reactRouterifiedProcedurePathPrefixes = procedurePathPrefixes.map(x => `${x}/:procedureType`);

const languagePathPrefixes = [
    '/languages',
];

const reactRouterifiedLanguagePathPrefixes = languagePathPrefixes.map(x => `${x}/:language/:specialty`);

const seoRoutes = [
    ...specialtyPathPrefixes,
    ...spanishSpecialtyPrefixes,
    ...procedurePathPrefixes,
    ...languagePathPrefixes,
];

const loweredSeoRoutes = seoRoutes.map(x => x.toLowerCase());

const seoRouteMatches = [
    ...reactRouterifiedProcedurePathPrefixes,
    ...reactRouterifiedSpecialtyPathPrefixes,
    ...reactRouterifiedLanguagePathPrefixes,
];

export {
    seoRouteMatches as default,
    seoRoutes,
    loweredSeoRoutes,
    localizedUrlMap,
};
